<div class="masthead bg-white pl-md-5 pr-md-5">
    <div class="row align-items-center">
        <div class="col">
            <p class="mb-0 h3 pb-4 pt-4">
                <i class="fa fa-group mr-3"></i>
                Manage security groups
            </p>
        </div>
        <div class="col text-right align-items-center d-flex justify-content-end">
       
            <button id="i" class="btn btn-primary ml-3 btn-sm" (click)="createSecurityGroupClicked()">Create security group<i class="ml-2 fa fa-plus"></i></button>

             <div class="form-group d-inline-block mb-0 ml-3">
                 <input type="text" [(ngModel)]="searchTerm" class="form-control" placeholder="Search security groups..." />
            </div>
        </div>
    </div>
</div>


<div class="container">
    <div class="row mt-5">
        <div class="col">
            <ul class="list-group mt-3">
                <li class="list-group-item list-group-item-action justify-content-between align-items-center" *ngFor="let item of securityGroups | arraypropertyfilter: 'name' : searchTerm" (click)="securityGroupClicked(item)">
                    <div>
                        <p class="mb-0" [ngClass]="{'text-muted strikethrough': item.disabled}">
                            <strong>{{item.name}}</strong>
                        </p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>
